import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter, inject,
  Input,
  OnInit,
  Output
} from '@angular/core';
import {
  EntityClassSelectorComponent,
  EntityInfoComponent,
  ExtRetentionTriggerSelectorComponent,
  FileTypeSelectorComponent,
  VisibleClassifiersMode
} from '|shared';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {SecurityCategoryDto} from '|api/codebook';
import {debounceTime, distinctUntilChanged, startWith} from 'rxjs/operators';
import {IczOnChanges, InaccessibleDirective, SectionComponent} from '@icz/angular-essentials';
import {AbstractFileCloseForm} from '../abstract-file-close-form';
import {ReactiveFormsModule} from '@angular/forms';
import {
  DatePickerComponent,
  FormAutocompleteComponent,
  FormFieldComponent,
  IczFormContainerDirective
} from '@icz/angular-form-elements';
import {EntityClassDto} from '|api/commons';
import {AsyncPipe} from '@angular/common';

@Component({
  selector: 'icz-file-close-form',
  templateUrl: './file-close-form.component.html',
  styleUrls: ['./file-close-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SectionComponent, EntityInfoComponent, ReactiveFormsModule, IczFormContainerDirective, InaccessibleDirective, FormAutocompleteComponent, FileTypeSelectorComponent, DatePickerComponent, FormFieldComponent, ExtRetentionTriggerSelectorComponent, EntityClassSelectorComponent, AsyncPipe]
})
export class FileCloseFormComponent extends AbstractFileCloseForm implements OnInit, IczOnChanges {
  private cd = inject(ChangeDetectorRef);
  @Input()
  settlementDate!: Date;
  @Input()
  showFileInfo = false;
  @Output()
  closeValid = new EventEmitter<boolean>();
  securityCategories: SecurityCategoryDto[] = [];
  @Input()
  entityClasses: EntityClassDto[] = [];

  formGroupsToCheck!: string[];

  readonly VisibleClassifiersMode = VisibleClassifiersMode;

  override codebooksLoaded() {
    super.codebooksLoaded();

    this.form.get('entityClassId')?.valueChanges.pipe(
      startWith(this.form.get('entityClassId')!.value),
      takeUntilDestroyed(this.destroyRef))
      .subscribe(entityClassId => {
        if (entityClassId) {
          const entityClass = this.entityClasses.find(ec => ec.id === entityClassId)!;
          const selectedDisposalSchedule = this.disposalSchedules.find(ds => ds.id === entityClass.disposalScheduleId)!;
          this.form.get('disposalScheduleId')!.setValue(selectedDisposalSchedule.id);
          this.fillRetentionSection(selectedDisposalSchedule);

          this.loadingService.doLoading(
            this.apiFileService.fileGetValidRetentionTriggerData({
              body: [{
                entityId: this.file.id,
                entityClassId: this.entityClassId
              }]
            }),
            this
          ).subscribe(validSchedule => {
            if (validSchedule.resultsPerEntity) {
              this.fillRetentionDataWithPrepare(validSchedule.resultsPerEntity[0]);
              this.updateDisposalData();
            }
          });
        }
      });

    this.form.get('yearOfRetentionPeriodStart')?.valueChanges.pipe(takeUntilDestroyed(this.destroyRef), distinctUntilChanged(), debounceTime(1000)).subscribe(_ => {
      this.updateDisposalData();
    });
  }

  override ngOnInit(): void {
    super.ngOnInit();

    this.form.valueChanges.pipe(debounceTime(250), takeUntilDestroyed(this.destroyRef)).subscribe(_ => {
      this.closeValid.emit(this.form.valid);
    });
  }
}
